"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _divider = _interopRequireDefault(require("../divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StackedLayout = function StackedLayout(_ref) {
  var header = _ref.header,
      footer = _ref.footer,
      body = _ref.body;
  return (0, _core.jsx)(_react.default.Fragment, null, header, header && (0, _core.jsx)(_divider.default, null), body, footer && (0, _core.jsx)(_divider.default, null), footer);
};

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  header: (0, _reactRequiredIf.default)(_propTypes.default.node, function (props) {
    return props.footer === undefined;
  }),
  footer: (0, _reactRequiredIf.default)(_propTypes.default.node, function (props) {
    return props.header === undefined;
  }),
  body: _propTypes.default.node.isRequired
}), (0, _recompose.setDisplayName)('StackedLayout'))(StackedLayout);

exports.default = _default;